import React from "react";
import { Spinner } from "react-bootstrap";

const CustomMessage = (
  message: string,
  type: 'success' | 'info' | 'warning' | 'error', // Specify the possible types
  enqueueSnackbar: (message: string, options?: any) => void // Adjust the type for enqueueSnackbar
) => {
  enqueueSnackbar(message, {
    variant: type,
    persist: ['success', 'warning', 'info', 'error'].includes(type) ? false : true,
    autoHideDuration: ['success', 'warning', 'info', 'error'].includes(type) ? 3000 : undefined,
  });
};

const Loader: React.FC = () => {
  return (
    <div className="mainLoader">
      <Spinner
        as="span" // Corrected the "as" prop value
        animation="border"
        role="status"
        aria-hidden="true" // Corrected the "aria-hidden" value
        variant="primary"
      />
    </div>
  );
};

export { CustomMessage, Loader };
